import { NgModule } from '@angular/core';

import { LoadingComponent } from './load.component';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from "@angular/material/progress-bar";

@NgModule({
    imports: [
        CommonModule,
        MatProgressBarModule
    ],
    exports: [
        LoadingComponent
    ],
    declarations: [LoadingComponent],
    providers: [],
})
export class LoadingModule { }
